import { FormProvider, useForm } from "react-hook-form";
import React from "react";
import SelectDateVente from "./SelectDateVente";
import QuantiteProduitsVente from "./QuantiteProduitsVente";
import MessageOuvertureVente from "./MessageOuvertureVente";
import StepperButton from "../../../../components/Button/StepperButton";
import Stack from "@mui/material/Stack";
import Step from "@mui/material/Step";
import StepContent from "@mui/material/StepContent";
import StepLabel from "@mui/material/StepLabel";
import Stepper from "@mui/material/Stepper";
import Typography from "@mui/material/Typography";
import SelectProduitsVente from "./SelectProduitsVente";
import emailjs from "emailjs-com";
import ErrorSubmitDataAlert from "../../../../components/Alert/ErrorSubmitDataAlert";
import SuccessSubmitDataAlert from "../../../../components/Alert/SuccessSubmitDataAlert";
import LoadingDataAlert from "../../../../components/Alert/LoadingDataAlert";
import PaperDialog from "../../../../components/Dialog/PaperDialog";
import { useData } from "../../../../lib/context/DataContext";
export default function OuvrirVente() {
	const [status, setStatus] = React.useState();
	const [activeStep, setActiveStep] = React.useState(0);

	const [mailContent, setMailContent] = React.useState("");

	const destinataires = ["amoisant@epb-paris.fr"];

	const { fetchDataVentes } = useData();

	const steps = [
		{
			label: "Période de vente",
			composant: <SelectDateVente />,
		},
		{
			label: "Sélection des produits",
			composant: <SelectProduitsVente />,
		},
		{
			label: "Quantité de produit à vendre",
			composant: <QuantiteProduitsVente />,
		},
		{
			label: "Partager la vente",
			composant: (
				<MessageOuvertureVente setMailContent={setMailContent} />
			),
		},
	];

	const showNext = () => {
		if (
			activeStep === 0 &&
			methods.watch("debutVente") &&
			methods.watch("finVente") &&
			methods.watch("livraisonVente")
		) {
			return false;
		} else if (activeStep === 1 && methods.watch("produitsEnVente")) {
			return false;
		} else if (activeStep === 2 && methods.watch("produitsEnVente")) {
			return false;
		} else if (activeStep === 3 && methods.watch("messagePartage")) {
			return false;
		} else return true;
	};

	const methods = useForm();

	const onSubmit = async (data) => {
		setStatus("Loading");

		const produitsEnVenteFiltres = data.produitsEnVente.map((p) => ({
			rowKey: p.rowKey,
			name: p.name,
			prix: p.prix,
			unite: p.unite,
			cover: p.cover,
			categorie: p.categorie,
			quantite: p.quantite ? p.quantite : 0,
		}));

		const nouvelleVente = {
			partitionKey: data.venteID,
			rowKey: data.venteID,
			debutVente: data.debutVente.format("DD MM YYYY"),
			finVente: data.finVente.format("DD MM YYYY"),
			livraisonVente: data.livraisonVente.format("DD MM YYYY"),
			produitsEnVente: JSON.stringify(produitsEnVenteFiltres),
		};

		try {
			const res = await fetch("/api/addVente", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(nouvelleVente),
			});

			if (res.ok) {
				setStatus("success");
				try {
					// Envoi à chaque destinataire
					await Promise.all(
						destinataires.map((email) =>
							emailjs.send(
								"service_wdaeza8", // ex: 'service_xxxx'
								"template_9ht1vwd", // ex: 'template_xxxx'
								{
									message: mailContent,
									to_email: email, // variable dynamique
								},
								"zfOysPm9GH2Kwx1ky" // ex: 'cC9uU0XYxxxxx'
							)
						)
					);
				} catch (error) {
					console.error("Erreur lors de l’envoi :", error);
				}
			} else {
				//const json = await res.json();
				//setErrorMessage(json.error || "Erreur inconnue");
				setStatus("error");
			}
		} catch (err) {
			//setErrorMessage(err.message || "Erreur réseau");
			setStatus("error");
		} finally {
			fetchDataVentes();
		}
	};

	return (
		<FormProvider {...methods}>
			<PaperDialog
				titre="Ouvrir une vente"
				onSubmit={methods.handleSubmit(onSubmit)}
				actions={
					<StepperButton
						activeStep={activeStep}
						setActiveStep={setActiveStep}
						size={steps.length - 1}
						disabled={showNext()}
						submitStatus={status}
					/>
				}
			>
				{status === "error" && (
					<ErrorSubmitDataAlert>
						Une erreur est survenue lors de l'ouverture de la vente
					</ErrorSubmitDataAlert>
				)}
				{status === "loading" && <LoadingDataAlert />}
				{status === "success" && (
					<SuccessSubmitDataAlert>
						la vente a été joutée avec success
					</SuccessSubmitDataAlert>
				)}
				{!status && (
					<Stepper
						orientation="vertical"
						activeStep={activeStep}
					>
						{steps.map((step) => (
							<Step key={step.label}>
								<StepLabel optional={step.info}>
									<Typography variant="h6">
										{step.label}
									</Typography>
								</StepLabel>
								<Stack
									component={StepContent}
									spacing={1}
									pl={5}
								>
									{step.composant}
								</Stack>
							</Step>
						))}
					</Stepper>
				)}
			</PaperDialog>
		</FormProvider>
	);
}
